
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';
import { AccountingPlanStatus } from 'enums/AccountingPlanStatus';


export class AccountingPlanRequestModel extends Model<AccountingPlanRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'guid', languageString: 'accountingPlanRequest.property.accountingPlanId' },
		{ name: 'pausedRegistrations', type: 'boolean', languageString: 'accountingPlanRequest.property.pausedRegistrations' },
		{ name: 'suspended', type: 'boolean', languageString: 'accountingPlanRequest.property.suspended' },
		{ name: 'ignorePriceAdjustments', type: 'boolean', languageString: 'accountingPlanRequest.property.ignorePriceAdjustments' }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public pausedRegistrations?: boolean;
	public suspended?: boolean;
	public ignorePriceAdjustments?: boolean;
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.pausedRegistrations = undefined;
		this.suspended = undefined;
		this.ignorePriceAdjustments = undefined;
		
	}
	getProperties(){
		return AccountingPlanRequestModel.classProperties;
	}
}
export class AccountingPlanSearchRequestModel extends Model<AccountingPlanSearchRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyIds', type: 'string[]', languageString: 'accountingPlanSearchRequest.property.companyIds', isArray: true },
		{ name: 'maxResults', type: 'number', languageString: 'accountingPlanSearchRequest.property.maxResults' },
		{ name: 'inActivePeriod', type: 'boolean', languageString: 'accountingPlanSearchRequest.property.inActivePeriod' },
		{ name: 'isSuspended', type: 'boolean', languageString: 'accountingPlanSearchRequest.property.isSuspended' },
		{ name: 'hasStartDate', type: 'boolean', languageString: 'accountingPlanSearchRequest.property.hasStartDate' },
		{ name: 'status', type: 'AccountingPlanStatus', languageString: 'accountingPlanSearchRequest.property.status' }
	];
	[key: string]: any;
	
	public companyIds: string[];
	public maxResults?: number;
	public inActivePeriod?: boolean;
	public isSuspended?: boolean;
	public hasStartDate?: boolean;
	public status?: AccountingPlanStatus;
    
	constructor(){
		super();
		this.companyIds = [];
		this.maxResults = undefined;
		this.inActivePeriod = undefined;
		this.isSuspended = undefined;
		this.hasStartDate = undefined;
		this.status = undefined;
		
	}
	getProperties(){
		return AccountingPlanSearchRequestModel.classProperties;
	}
}
export class StartOfAccountingRequestModel extends Model<StartOfAccountingRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'products', type: 'ProductInfoModel[]', languageString: 'startOfAccountingRequest.property.products', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductInfoModel }, properties: () => { return ProductInfoModel.classProperties } },
		{ name: 'companyId', type: 'guid', languageString: 'startOfAccountingRequest.property.companyId' },
		{ name: 'billingAddress', type: 'AddressModel', languageString: 'startOfAccountingRequest.property.billingAddress', isHidden: true, isObject: true, new: () => { return new AddressModel }, properties: () => { return AddressModel.classProperties } },
		{ name: 'setStatus', type: 'AccountingPlanStatus', languageString: 'startOfAccountingRequest.property.setStatus' }
	];
	[key: string]: any;
	
	public products: ProductInfoModel[];
	public companyId?: string;
	public billingAddress?: AddressModel;
	public setStatus?: AccountingPlanStatus;
    
	constructor(){
		super();
		this.products = [];
		this.companyId = undefined;
		this.billingAddress = undefined;
		this.setStatus = undefined;
		
	}
	getProperties(){
		return StartOfAccountingRequestModel.classProperties;
	}
}
export class ProductInfoModel extends Model<ProductInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'guid', languageString: 'productInfo.property.productPlanId' },
		{ name: 'paymentScheme', type: 'number', languageString: 'productInfo.property.paymentScheme' },
		{ name: 'equalizingAmount', type: 'number', languageString: 'productInfo.property.equalizingAmount' },
		{ name: 'startDate', type: 'Date', languageString: 'productInfo.property.startDate' },
		{ name: 'endDate', type: 'Date', languageString: 'productInfo.property.endDate' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public paymentScheme: number;
	public equalizingAmount: number;
	public startDate?: Date;
	public endDate?: Date;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.paymentScheme = 0;
		this.equalizingAmount = 0;
		this.startDate = undefined;
		this.endDate = undefined;
		
	}
	getProperties(){
		return ProductInfoModel.classProperties;
	}
}
export class CancellationRequestModel extends Model<CancellationRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'guid', languageString: 'cancellationRequest.property.accountingPlanId' },
		{ name: 'discontinuedProductPlanIds', type: 'string[]', languageString: 'cancellationRequest.property.discontinuedProductPlanIds', isArray: true }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public discontinuedProductPlanIds: string[];
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.discontinuedProductPlanIds = [];
		
	}
	getProperties(){
		return CancellationRequestModel.classProperties;
	}
}
export class AddressModel extends Model<AddressModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyName', type: 'string', languageString: 'address.property.companyName' },
		{ name: 'city', type: 'string', languageString: 'address.property.city' },
		{ name: 'streetAddress', type: 'string', languageString: 'address.property.streetAddress' },
		{ name: 'contactName', type: 'string', languageString: 'address.property.contactName' },
		{ name: 'emailAddress', type: 'string', languageString: 'address.property.emailAddress' },
		{ name: 'phoneNumber', type: 'string', languageString: 'address.property.phoneNumber' },
		{ name: 'zipcode', type: 'string', languageString: 'address.property.zipcode' },
		{ name: 'vatNumber', type: 'string', languageString: 'address.property.vatNumber' },
		{ name: 'glnNumber', type: 'string', languageString: 'address.property.glnNumber' }
	];
	[key: string]: any;
	
	public companyName: string;
	public city: string;
	public streetAddress: string;
	public contactName: string;
	public emailAddress: string;
	public phoneNumber: string;
	public zipcode: string;
	public vatNumber: string;
	public glnNumber: string;
    
	constructor(){
		super();
		this.companyName = '';
		this.city = '';
		this.streetAddress = '';
		this.contactName = '';
		this.emailAddress = '';
		this.phoneNumber = '';
		this.zipcode = '';
		this.vatNumber = '';
		this.glnNumber = '';
		
	}
	getProperties(){
		return AddressModel.classProperties;
	}
}

